export default __webpack_public_path__ + "static/media/exclamation_point.14196720.svg";